import { Confirmation } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
  DeletingUsedItemModal,
  UsageRelation,
} from 'src/components/common/modals/deleting-used-item-modal';

interface DeleteConfirmationCheckModalProps {
  id?: string;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  onCheckItemUsageBeforeDelete?: (
    id?: string,
  ) => Promise<UsageRelation[] | undefined>;
  itemUsagesErrorTitle?: string;
  itemUsagesErrorDescription?: string;
}

export const DeleteConfirmationCheckModal = ({
  id,
  onClose,
  onConfirm,
  message,
  onCheckItemUsageBeforeDelete,
  itemUsagesErrorTitle = 'Deleting item error',
  itemUsagesErrorDescription = 'The item is used in the following places:',
}: DeleteConfirmationCheckModalProps) => {
  const [deletedItemUsages, setDeletedItemUsages] = useState<UsageRelation[]>();

  const onDeleteConfig = async () => {
    if (onCheckItemUsageBeforeDelete) {
      const itemUsages = await onCheckItemUsageBeforeDelete?.(id);
      if (itemUsages?.length) {
        setDeletedItemUsages(itemUsages);
        return;
      }
    }

    onConfirm();
  };

  return (
    <>
      <Confirmation
        open={!deletedItemUsages?.length}
        onClose={onClose}
        onConfirm={onDeleteConfig}
        message={message}
      />

      {deletedItemUsages?.length && (
        <DeletingUsedItemModal
          relations={deletedItemUsages}
          title={itemUsagesErrorTitle}
          description={itemUsagesErrorDescription}
          onClose={() => setDeletedItemUsages(undefined)}
        />
      )}
    </>
  );
};
